import { writable } from "svelte/store";
export default class SectionInstance {
    constructor(sectionId, required) {
        this.sectionId = sectionId;
        this.required = writable(required);
    }
}
